import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import SubcategoryHintBox from './SubcategoryHintBox'

interface Props {
  parentVisibleToCustomer: boolean
  parentVisibleToInstaller: boolean
}

const SubcategoryRestrictions: React.FC<Props> = ({ parentVisibleToCustomer, parentVisibleToInstaller }) => {
  const { t } = useCustomTranslation()
  const message =
    !parentVisibleToCustomer && !parentVisibleToInstaller
      ? t('documents.add-subcategory.restrictions.hint.none')
      : !parentVisibleToCustomer
      ? t('documents.add-subcategory.restrictions.hint.customer')
      : !parentVisibleToInstaller
      ? t('documents.add-subcategory.restrictions.hint.installer')
      : ''

  return (
    <SubcategoryHintBox>
      <Typography variant={'caption'}>{message}</Typography>
    </SubcategoryHintBox>
  )
}

export default SubcategoryRestrictions
